import React, { Component } from 'react';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import slugify from 'slugify';

class SEOAnalysis extends Component {
    htmlToText = (htmlString) => {
        const el = document.createElement('div');
        el.innerHTML = htmlString;
        return el.textContent;
      }
    render() {
        const {meta_title, meta_description, meta_keywords, description, slug, link} = this.props;
        const main_keyword = meta_keywords.split(',')[0];
        const count_text_main_keyword = main_keyword.split(" ").length;
        const convert_description = description && draftToHtml(convertToRaw(description.getCurrentContent()));
        const desc = description && this.htmlToText(convert_description);
        const count_kw_on_descr = desc.toLowerCase().split(main_keyword.toLowerCase()).length-1;
        const text_row_1 = desc.split("\n")[0];
        const count_img = convert_description.split("img").length-1;
        const check_slug = slug && slugify(main_keyword).split("-").filter(keyword => {
            return slug.indexOf(keyword.toLowerCase()) !== -1
        })
        const count_row = desc.split("\n").length-1
        const check_length_row = desc.split("\n").filter(row => {
            return row.split(" ").length > 19
        });
        const check_length_row_1 = desc.split("\n").filter(row => {
            return row.split(" ").length > 150
        });
        const check_length_row_2 = desc.split("\n").filter(row => {
            return row.split(" ").length > 151
        });
        const length_row_percent = ((check_length_row.length)/count_row)*100
        const check_length_row_percent = length_row_percent > 25 ? true : false;
        var div = document.createElement('div');
        div.innerHTML = convert_description;
        const check_link = div.getElementsByTagName("a");
        const check_img = div.getElementsByTagName("img");
        var hrefs = [];
        var srcs = [];
        for (var i = 0; i<check_link.length; i++)
        {   
            hrefs.push(check_link[i].host);
        }
        for (var j = 0; j < check_img.length; j++)
        {   
            srcs.push(check_img[j].alt);
        }
        const check_link_inbound = hrefs.length>0 && hrefs.filter(item => {
            return item === link
        })
        const check_link_outbound = hrefs.length>0 && hrefs.filter(item => {
            return item !== link
        })
        const check_img_inbound = srcs.length>0 && srcs.filter(item => {
            return item.toLowerCase() === main_keyword.toLowerCase()
        })
        // console.log(convert_description.match(/href="([^"]*)/))
        return (
            <ul className="listDots">
                {desc.length-1>0 &&
                    <li>
                        <span className={`dot ${
                        desc.length > 0 ?
                        desc.length > 299 ?
                            'bgSuccess'
                        :  'bgDanger'
                        :  'bgDanger'
                        }`} />
                        <span className="text">
                        <strong>Độ dài văn bản:</strong> {
                        desc.length > 0 ?
                        desc.length > 299 ?
                        'Văn bản chứa '+ desc.length +' từ. Rất tốt!'
                        :  'Văn bản chứa '+ desc.length +' từ. Số lượng từ quá ít so với mức tối thiểu 300 từ.'
                        :  'Văn bản chứa 0 từ. Số lượng từ quá ít so với mức tối thiểu 300 từ. Hãy thêm nội dung.'
                        }
                        </span>
                    </li>
                }
                {
                    desc.length-1>0 && 
                    <li>
                    <span className={`dot ${
                        check_length_row_1.length>0 ? check_length_row_2.length>0 ? 'bgDanger' : 'bgWarning' : 'bgSuccess'
                    }`} />
                    <span className="text">
                    <strong>Độ dài đoạn văn:</strong> {
                        check_length_row_1.length>0 ? check_length_row_2.length>0 ? 'Có 1 đoạn văn chứa nhiều hơn số từ khuyến nghị tối đa là 150 từ. Hãy rút gọn đoạn văn!' : 'Có 1 đoạn văn chứa nhiều hơn số từ khuyến nghị tối đa là 150 từ. Hãy rút gọn đoạn văn!' : 'Không có các đoạn văn quá dài. Rất tốt!'
                    }
                    </span>
                    </li>
                }
                {
                    desc.length-1>0 && 
                    <li>
                    <span className={`dot ${
                        check_length_row_percent ? 'bgDanger' : 'bgSuccess'
                    }`} />
                    <span className="text">
                    <strong>Độ dài của câu:</strong> {
                        check_length_row_percent ? length_row_percent+' trong số các câu chứa 20 từ, nhiều hơn mức khuyến nghị tối đa là 25%. Hãy rút gọn các câu.' : 'Tuyệt!'
                    }
                    </span>
                    </li>
                }
                {(desc.length-1 > 0 && meta_keywords) &&
                    <li>
                    <span className={`dot ${
                        text_row_1.toLowerCase().indexOf(main_keyword.toLowerCase()) !== -1 ? 'bgSuccess' : 'bgDanger'
                    }`} />
                    <span className="text">
                    <strong>Cụm từ khoá trong phần giới thiệu:</strong> {
                        text_row_1.toLowerCase().indexOf(main_keyword.toLowerCase()) !== -1 ? ' Rất tốt!' : ' Cụm từ khóa của bạn hoặc các từ đồng nghĩa với nó không xuất hiện trong đoạn văn đầu.'
                    }
                    </span>
                    </li>
                }
                {(desc.length-1 > 0 && meta_keywords) &&
                    <li>
                    <span className={`dot ${
                        count_kw_on_descr > 1 ?
                        count_kw_on_descr > 7 ? 
                        'bgDanger'
                    :  'bgSuccess'
                    :  'bgDanger'
                    }`} />
                    <span className="text">
                    <strong>Mật độ cụm từ khoá:</strong> {
                        count_kw_on_descr > 1 ?
                        count_kw_on_descr > 7 ? 
                        'Cụm từ khóa chính xuất hiện '+count_kw_on_descr+' lần. Mức đó nhiều hơn mức tối đa khuyến nghị là 7 lần cho một văn bản với độ dài như thế này. Đừng tối ưu quá mức!'
                    :  'Cụm từ khóa chính xuất hiện '+count_kw_on_descr+' lần. Rất tốt!'
                    :  'Cụm từ khóa chính xuất hiện '+count_kw_on_descr+' lần. Mức đó thấp hơn mức tối thiểu khuyến nghị là 2 lần cho một văn bản với độ dài như thế này.'
                    }
                    </span>
                    </li>
                }
                {
                    desc.length-1 > 0 &&
                    <li>
                    <span className={`dot ${
                            count_img > 0 ?
                            check_img_inbound.length>0 ? 'bgSuccess'
                        : 'bgWarning'
                        :  'bgDanger'
                    }`} />
                    <span className="text">
                    <strong>Các thuộc tính mô tả ảnh (alt):</strong> {
                        count_img > 0 ?
                        check_img_inbound.length>0 ? 'Rất tốt!'
                    : 'Ảnh trong trang đã có thuộc tính alt, nhưng bạn chưa đặt cụm từ khóa. Khắc phục ngay!'
                    :  'Không có ảnh trong trang. Hãy thêm ảnh!'
                    }
                    </span>
                    </li>
                }
                {
                    desc.length-1 > 0 &&
                    <li>
                    <span className={`dot ${
                            check_link_inbound.length > 0 ?
                            'bgSuccess'
                        :  'bgDanger'
                    }`} />
                    <span className="text">
                    <strong>Các đường dẫn nội bộ:</strong> {
                        check_link_inbound.length > 0 ?
                        'Bạn có đủ các đường dẫn nội bộ. Rất tốt!'
                    :  'Không có đường dẫn nội bộ trong trang này, Hãy thêm một số đường dẫn nội bộ tốt.'
                    }
                    </span>
                    </li>
                }
                {
                    desc.length-1 > 0 &&
                    <li>
                    <span className={`dot ${
                            check_link_inbound.length > 0 ?
                            'bgSuccess'
                        :  'bgDanger'
                    }`} />
                    <span className="text">
                    <strong>Các đường dẫn nội bộ:</strong> {
                        check_link_inbound.length > 0 ?
                        'Bạn có đủ các đường dẫn nội bộ. Rất tốt!'
                    :  'Không có đường dẫn nội bộ trong trang này, Hãy thêm một số đường dẫn nội bộ tốt.'
                    }
                    </span>
                    </li>
                }
                {
                    desc.length-1 > 0 &&
                    <li>
                    <span className={`dot ${
                            check_link_outbound.length > 0 ?
                            'bgSuccess'
                        :  'bgDanger'
                    }`} />
                    <span className="text">
                    <strong>Các đường dẫn ra ngoài trang:</strong> {
                        check_link_inbound.length > 0 ?
                        'Rất tốt!'
                    :  'Không có các đường dẫn ra ngoài trang. Hãy thêm một số đường dẫn!'
                    }
                    </span>
                    </li>
                }
                <li>
                    <span className={`dot ${
                    meta_title.length > 0 ?
                    meta_title.length > 9 ?
                    meta_title.length > 29 ? 
                    meta_title.length > 48 ? 
                    meta_title.length > 54 ?
                    meta_title.length > 65 ? 
                    meta_title.length > 75 ? 
                        'bgDanger' 
                    :  'bgDanger'
                    :  'bgSuccess'
                    :  'bgSuccess'
                    :  'bgSuccess'
                    :  'bgWarning'
                    :  'bgDanger'
                    :  'bgDanger'
                    }`} />
                    <span className="text">
                    <strong>Độ rộng của tiêu đề SEO:</strong> {
                    meta_title.length > 0 ?
                    meta_title.length > 9 ?
                    meta_title.length > 29 ? 
                    meta_title.length > 48 ? 
                    meta_title.length > 54 ?
                    meta_title.length > 65 ? 
                    meta_title.length > 75 ? 
                    'Độ dài của tiêu đề SEO vượt quá giới hạn có thể nhìn thấy được. Hãy rút gọn hơn.' 
                    : 'Độ dài của tiêu đề SEO vượt quá giới hạn có thể nhìn thấy được. Hãy rút gọn hơn.'
                    : 'Tuyệt vời!'
                    : 'Rất tốt!'
                    :  'Tốt!'
                    :  'Tiêu đề SEO ngắn. Hãy dùng khoảng trống để thêm các biến thể cụm từ khóa hoặc tạo một bài viết kêu gọi hành động thuyết phục.'
                    :  'Tiêu đề SEO quá ngắn. Hãy dùng khoảng trống để thêm các biến thể cụm từ khóa hoặc tạo một bài viết kêu gọi hành động thuyết phục.'
                    :  'Hãy tạo một tiêu đề SEO'
                    }
                    </span>
                </li>
                <li>
                    <span className={`dot ${
                    meta_description.length > 0 ?
                    meta_description.length > 75 ?
                    meta_description.length > 100 ?
                    meta_description.length > 154 ?
                    meta_description.length > 165 ?
                    meta_description.length > 175 ?
                    'bgDanger'
                    : 'bgDanger'
                    : 'bgSuccess'
                    : 'bgSuccess'
                    : 'bgWarning'
                    : 'bgDanger'
                    : 'bgDanger'
                    }`} />
                    <span className="text">
                    <strong>Độ dài của mô tả SEO:</strong> {
                    meta_description.length > 0 ?
                    meta_description.length > 75 ?
                    meta_description.length > 100 ?
                    meta_description.length > 154 ?
                    meta_description.length > 165 ?
                    meta_description.length > 175 ?
                    'Mô tả Meta vượt quá 156 ký tự. Để đảm bảo toàn bộ mô tả này được nhìn thấy, bạn nên giảm độ dài! '
                    : 'Mô tả Meta vượt quá 156 ký tự. Để đảm bảo toàn bộ mô tả này được nhìn thấy, bạn nên giảm độ dài!'
                    : 'Tuyệt vời!'
                    : 'Rất tốt!'
                    : 'Mô tả Meta quá ngắn (dưới 120 ký tự). Có thể lên tới 156 ký tự. Hãy dùng những khoảng trống!'
                    : 'Mô tả Meta quá ngắn (dưới 120 ký tự). Có thể lên tới 156 ký tự. Hãy dùng những khoảng trống!'
                    : 'Không có mô tả meta. Các máy tìm kiếm sẽ hiển thị đoạn văn bản từ trang.'
                    }
                    </span>
                </li>
                <li>
                    <span className={`dot ${
                        meta_keywords ? 'bgSuccess' : 'bgDanger'
                    }`} />
                    <span className="text">
                    <strong>Độ dài cụm từ khoá:</strong> 
                    {meta_keywords ? 
                        ' Rất tốt!'
                    : ' Không có cụm từ khóa chính nào được đặt cho trang này.'}
                    </span>
                </li>
                {(meta_title && meta_keywords) &&
                <li>
                    <span className={`dot ${
                        meta_title.toLowerCase().indexOf(main_keyword.toLowerCase()) !== -1 ? 'bgSuccess' : 'bgDanger'
                    }`}>
                    </span>
                    <span className="text">
                        <strong>Từ khoá trong tiêu đề:</strong> 
                        {meta_title.toLowerCase().indexOf(main_keyword.toLowerCase()) !== -1 ? ' ừ khóa khớp chính xác xuất hiện ở đầu tiêu đề SEO. Rất tốt!' : ' Không khớp chính xác với từ khóa. Hãy viết từ khóa chính xác trong tiêu đề SEO.'}
                    </span>
                </li>
                }
                {(meta_description && meta_keywords) &&
                <li>
                    <span className={`dot ${
                        meta_description.toLowerCase().indexOf(main_keyword.toLowerCase()) !== -1 ? 'bgSuccess' : 'bgDanger'
                    }`}>
                    </span>
                    <span className="text">
                        <strong>Cụm từ khóa trong mô tả meta:</strong> 
                        {meta_description.toLowerCase().indexOf(main_keyword.toLowerCase()) !== -1 ? ' Cụm từ khóa hoặc từ đồng nghĩa xuất hiện trong mô tả meta. Rất tốt!' : ' Mô tả meta đã có, nhưng không chứa cụm từ khóa.'}
                    </span>
                </li>
                    }
                {
                    (slug && meta_keywords) &&
                    <li>
                        <span className={`dot ${
                            count_text_main_keyword > check_slug.length ? 'bgWarning' : 'bgSuccess'
                        }`}>
                        </span>
                        <span className="text">
                            <strong>Từ khoá trong đường dẫn (slug):</strong> 
                            {count_text_main_keyword > check_slug.length ? '(Một phần) từ khóa của bạn không xuất hiện trong slug. Thay đổi!' : 'Rất tốt!'}
                        </span>
                    </li>
                }
                </ul>
        )
    }
}

export default SEOAnalysis
